export * from './TS_Loader.js';
//# sourceMappingURL=index.js.map